export class Permission {
    permissionId: number;
    description: string;
    operationId: number;
    elementTypeId: number;
    entityTypeId: number;
    permitted: boolean;
}

